import api from "./api";

const VehicleInsuranceService = {

  create: async (data) => {
    const response = await api.post("/vehicleInsurance/save", data);
    return response.data;
  },


  getAll: async () => {
    const response = await api.get("/vehicleInsurance/get");
    return response.data.data || response.data;
  },


  getById: async (id) => {
    const response = await api.get(`/vehicleInsurance/getById/${id}`);
    return response.data.data || response.data;
  },

  //   getByCompanyId: async (companyId) => {
  //   const res = await api.get(`/vehicleInsurance/getByCompany/${companyId}`);
  //   return res.data;
  // },

  getByCompanyId: async (companyId, pageNumber, noOfRows, search = "") => {
    const res = await api.get(
      `/vehicleInsurance/getByCompany/${companyId}?pageNumber=${pageNumber}&noOfRows=${noOfRows}&search=${search}`
    );
    return res.data.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/vehicleInsurance/${id}`, data);
    return response.data;
  },


  remove: async (id) => {
    const response = await api.delete(`/vehicleInsurance/${id}`);
    return response.data;
  },


  getActive: async () => {
    const response = await api.get("/vehicleInsurance/active/list");
    return response.data.data || response.data;
  },


  updateStatus: async (id) => {
    const response = await api.put(`/vehicleInsurance/updateStatus/${id}`);
    return response.data;
  },

  // 🔹 EXPORT Vehicle Insurance
  exportVehicleInsurance: async (companyId,) => {
    const response = await api.get(`/vehicleInsurance/export?companyId=${companyId}`);
    return response.data;
  },
};

export default VehicleInsuranceService;
